import { getApiConfig } from '@foundation/apis/ApiConfig';

import { handleApiResponse } from './helpers/handleApiResponse';

type SetDefaultInstrumentOptions = {
  readonly instrumentId: string;
  readonly bearerToken: string;
};

export async function setDefaultPaymentInstrument(
  options: SetDefaultInstrumentOptions,
) {
  const { paymentsApiUrl } = getApiConfig();
  const { instrumentId, bearerToken } = options;

  const response = await fetch(
    `${paymentsApiUrl}/paymentinstruments/${instrumentId}/default`,
    {
      method: 'PATCH',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${bearerToken}`,
      },
    },
  );

  return handleApiResponse<void>(
    response,
    'Failed to set default payment instrument',
  );
}
